import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import SortDirection from 'owa-service/lib/contract/SortDirection';
import { SortColumn, TableView } from 'owa-mail-list-store';
import { ActionSource } from 'owa-mail-store';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

export default {
    selectFilter: {
        name: 'TnS_SelectFilter',
        customData: (viewFilter: ViewFilter, actionSource: ActionSource) => [
            viewFilter,
            actionSource,
        ],
    },

    selectSort: {
        name: 'TnS_MailListSelectSort',
        customData: (
            sortColumn: SortColumn,
            sortDirection: SortDirection,
            tableView: TableView,
            actionSource: ActionSource
        ) => [
            sortColumn,
            sortDirection,
            actionSource,
            tableView.totalRowsInView,
            folderIdToName(tableView.tableQuery.folderId),
        ],
    },
};
